<template lang="html">
  	<div class="">
        <p class="text-muted">Exports will be sent via email. Recurring options are coming soon. :)</p>
        <div class="alert alert-danger" v-if="Object.keys(errors).length > 0">
            <p><strong>Whoops!</strong> Something went wrong!</p>
            <br>
            <ul>
                <li v-for="error in errors">
                    {{ error[0] }}
                </li>
            </ul>
        </div>
        <form@submit.prevent="queueExport">
            <div class="form-group">
                <label for="type">Client</label>
                <select class="form-control" v-model="form.client" id="type">
                    <option :value="null">Select a Client</option>
                    <option v-for="client in clients" :value="client.slug">{{ client.name }}</option>
                </select>
            </div>
            <div class="form-group">
                <label for="duration">Min Duration</label>
                <input class="form-control" type="number" name="duration" v-model="form.duration">
            </div>
            <div class="form-group">
                <label>Range</label>
                <div class="level">
                    <datepicker v-model="form.start" format="yyyy-MM-dd" icons-font="fa" placeholder="Start"></datepicker>
                    <datepicker v-model="form.end" format="yyyy-MM-dd" icons-font="fa" placeholder="End"></datepicker>
                </div>
            </div>
            <div class="form-group">
                <label for="increment">Increment</label>
                <select class="form-control" v-model="form.increment" id="increment">
                    <option :value="null">Select an Increment</option>
                    <option value="Total">Total</option>
                    <option value="Day">Day</option>
                    <option value="Month">Month</option>
                    <option value="Quarter">Quarter</option>
                    <option value="Year">Year</option>
                </select>
            </div>
            <div class="form-group">
                <button class="btn btn-primary" type="submit" :class="{'btn-loading': loading}" :disabled="!submittable || loading">Export</button>
            </div>
  		</form>
  	</div>
</template>

<script>
import { datepicker, select } from 'vue-strap';

var Exports = require('./mixins/Exports');

export default {
    mixins: [Exports],

    components: { datepicker, vSelect: select },

    data() {
        return {
            form: {
                type: 'phonecalls',
                client: null,
                increment: null,
                start: '',
                end: '',
                duration: 0,
            }
        }
    },

    mounted() {
        this.getClients();
    },

    computed: {
        submittable() {
            return Object.values(this.form).filter(n => n === null || n === '').length === 0;
        },
    },

    methods: {
        reset() {
            this.form = {
                type: 'phonecalls',
                client: null,
                increment: null,
                start: '',
                end: '',
                duration: 0,
            }
        },

        queueExport() {
            this.loading = true;
            let query = this.convertToQueryString();
            axios.get(`/api/reports/${this.form.client}/${this.form.type}/?email=true&${query}`)
                .then(({ data }) => {
                    Bus.$emit('hide-export-builder');
                    Bus.$emit('show-success-alert', data.message);
                    this.reset();
                    this.loading = false;
                })
                .catch((error) => {
                    this.errors = error.response.data.errors
                    this.loading = false
                });
        },
    }
}
</script>

<style lang="css" scoped>
    .level {
        display: flex;
        justify-content: space-between;
    }
    .datepicker {
        width: 48%;
    }

    #metrics-container > div {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/exports/PhonecallExportBuilder.vue